import React, {useState} from 'react';
import {NavLink} from 'react-router-dom';
import {Box, ListItemButton, ListItemIcon, ListItemText} from '@mui/material';
import Sidebar from '../components/Sidebar';
import { Outlet } from 'react-router-dom';
import {ExitToApp} from "@mui/icons-material";
import Icon from "../components/Icon";

const Dashboard: React.FC = () => {
    const [openClass, setOpenClass] = useState<string>('');
    const handleLogoClick = async () => {
        openClass === "" ? setOpenClass(" open") : setOpenClass("")
    };
    const handleCloseMenuClick = async () => {
        setOpenClass("")
    };
    return (
        <Box sx={{ display: 'flex', height: '100vh' }}>
            <Box className={"mainMenu" + openClass}>
                <Sidebar onLogoClick={handleLogoClick} onCloseMenuClick={handleCloseMenuClick}/>
                <Box className='menu-item' sx={{mb: 2}}>
                    <ListItemButton component={NavLink} to="/logout">
                        <ListItemIcon><Icon name="logout" /></ListItemIcon>
                        <ListItemText primary="Выход" />
                    </ListItemButton>
                </Box>
            </Box>
            <Box className='dahboardContent' component="main" sx={{ flexGrow: 1, bgcolor: '#50329112' }}>
                <Outlet />
            </Box>
        </Box>
    );
};

export default Dashboard;